import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { applicationUrls } from '../../../../../sharedweb/helpers/urls';
import { EventsService } from '../events/events.service';
import { EVENTS } from '../../../_helpers/constants';
import { ConnectivityMap } from '../connectivity/connectivity.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InternetConnectivityService {

  isInternetConnected = true;
  internetConnecitivity = new BehaviorSubject<boolean>(this.isInternetConnected);

  constructor(
    private _httpClient: HttpClient,
    private eventService: EventsService
  ) { }

  initSubscriptions() { 
    this.eventService.subscribe(EVENTS.CHECK_INTERNET, () => {
      this.checkConnectivity();
    });
  }

  checkConnectivity() { 
    this.getPublicIPAddress().subscribe((response: any) => {
      this.isInternetConnected = true;
      this.internetConnecitivity.next(this.isInternetConnected);
    }, 
    (error) => { 
      this.isInternetConnected = false;
      this.internetConnecitivity.next(this.isInternetConnected);
    });
  }

  getPublicIPAddress() {
    const url = applicationUrls.geolocationAPIUrl;

    return this._httpClient.get(url);
  }
}
